import { ServiceGroup } from '../types/diagram.types';

export const GROUP_COLORS: Record<ServiceGroup, string> = {
  Gateways: '#0D47A1',
  'Auth/User': '#1565C0',
  Finance: '#1B5E20',
  Trading: '#B71C1C',
  'Market Data': '#01579B',
  'Quick Exchange': '#E65100',
  Acquiring: '#4A148C',
  Crypto: '#006064',
  Compliance: '#4E342E',
  Notifications: '#37474F',
  Support: '#00695C',
};

export const ZONE_COLORS = {
  'zone-external': { bg: 'rgba(158,158,158,0.07)', border: '#9E9E9E', label: 'Внешний' },
  'zone-dmz':      { bg: 'rgba(255,109,0,0.07)',   border: '#FF6D00', label: 'DMZ' },
  'zone-kafka':    { bg: 'rgba(255,143,0,0.07)',   border: '#FF8F00', label: 'Kafka (Z5)' },
  'zone-internal': { bg: 'rgba(21,101,192,0.07)', border: '#1565C0', label: 'Внутренний' },
  'zone-partners': { bg: 'rgba(106,27,154,0.07)', border: '#6A1B9A', label: 'Партнёры' },
};
